import type { ReactNode } from "react";
import Box from "@mui/material/Box";

interface SnapshotContentProps {
  children: ReactNode;
}

/** A Snapshot page's content below its header: its sections, scrolling together under the header. */
export const SnapshotContent = (props: SnapshotContentProps) => {
  const { children } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        gap: 1,
        minHeight: 0,
        overflowY: "auto",
        pb: 3,
        scrollbarGutter: "stable",
        px: 3,
      }}
    >
      {children}
    </Box>
  );
};
